import React from 'react';
import { useLocation } from 'react-router-dom';
import { /*Card, CardContent*/ } from '../components/ui/card';
import PricingTable from '../components/PricingTable';
import { useUser, UserProfile } from '@clerk/clerk-react';

export default function Suscription() {
  const { isSignedIn, user } = useUser();
  const location = useLocation();
  const showBillingUI = location.pathname.startsWith('/suscription/billing');

  // Detect a subscription flag in common Clerk metadata locations.
  // This is deliberately permissive: projects may store subscription
  // info in publicMetadata or unsafeMetadata under different keys.
  const hasSubscription = Boolean(
    user && (
      user.publicMetadata?.subscriptionActive ||
      user.publicMetadata?.plan ||
      user.unsafeMetadata?.subscriptionActive ||
      user.unsafeMetadata?.plan
    )
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {!hasSubscription ? (
          <div>
            <h2 className="text-2xl font-bold mb-6">Choose a plan</h2>
            <PricingTable isSignedIn={isSignedIn} />
            <p className="mt-4 text-sm text-slate-600">If you already have an active subscription, sign in to manage it.</p>
            <p className="mt-2 text-sm text-slate-600">To subscribe: open <a href="/suscription/billing" className="text-indigo-600 underline">Billing</a>, choose <strong>Switch plan</strong> → <strong>Premium</strong>, then complete the subscribe &amp; payment flow.</p>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-bold mb-6">Manage your subscription</h2>
            <UserProfile routing="path" path="/suscription" />
          </div>
        )}

        {/*
          Mount Clerk's UserProfile also for signed-in users who are not yet
          subscribed. This allows the billing UI to appear at `/suscription/billing`
          without navigating away. We keep it hidden unless the URL path indicates
          the billing route so it doesn't affect the default layout.
        */}
        {isSignedIn && (
          <div className={showBillingUI ? 'mt-6' : 'hidden'}>
            <UserProfile routing="path" path="/suscription" />
          </div>
        )}
      </div>
    </div>
  );
}
